import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { DashboardService } from 'src/app/services/dashboard.service';
import { ReportsService } from 'src/app/services/reports.service';
import { first } from 'rxjs';
import saveAs from 'file-saver';
import { inventory } from 'src/app/models/department-reports.model';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { shareReplay } from 'rxjs/operators';
import { BaseService } from 'src/app/services/common/base.service';

@Component({
  selector: 'app-error-tracking',
  templateUrl: './error-tracking.component.html',
  styleUrls: ['./error-tracking.component.scss']
})
export class ErrorTrackingComponent implements OnInit {

  errordata: any[];
  verfAppArea: any;
  pendingArea: any;
  incompleteAppArea: any;
  rejectedAppArea: any;
  changeRequestAppArea: any;
  totalAppArea: any;
  targetArea: any;
  grandVerfAppArea: number;
  grandPendingArea: number;
  grandIncompleteAppArea: number;
  grandRejectedAppArea: number;
  grandChangeRequestAppArea: number;
  grandTotalAppArea: number;
  grandTargetArea: number;
  arrayIndex: number;
  tempVendorMiArea: any[];
  appVerificationItems: MenuItem[];
  appVerificationModel: any[];
  filteredDataForExport: any = [];
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];
  public filteredData: any = [];
  public totalSelectedApp: any = 0;
  public totalSubToFarmer: any = 0;
  public totalSubToVendor: any = 0;
  public totalFarmerRefund: any = 0;

  public userID: any;
  displayMaximizable: boolean;
  displayMaximizable_totalApp: boolean;
  displayMaximizable_pendingApp: boolean;
  drilldownDetails: any;
  pendingType: any;
  displayMaximizable_rejectedApp: any;
  vendorName: any;
  name: any;
  routePath: any;
  subjectSub: any;
  selectedYear: any;
  public subscriptions: any = [];
  public loading: boolean = false;
  public visible: boolean;
  public selectedData:any;
  constructor(
    private reportsService: ReportsService,
    private messageService: MessageService,
    private dashboard: DashboardService,
    private router: Router,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private service: BaseService,
    private apiService: DashboardService,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit(): void {

    this.loadData()
    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.appVerificationModel, "Inventory_report");
        }
      },
      // {
      //   label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
      //     this.downloadSheetAsPdf(this.appVerificationModel, "Inventory_report");
      //   }
      // },
    ];
  }
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if (this.subjectSub) {
      this.subjectSub.unsubscribe()
    }
  }

  loadData() {
    // this.loader.start();
    this.loading = true;
    let sub = this.dashboard.getErrorTracking()
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.activityRecordService.activityRecord(this.userID, 'Inventory Report', '', new Date(), 'Success');
          // this.loader.close();
          this.loading = false;

          if (data?.length > 0) {
            this.errordata = data;
            this.appVerificationModel = data;


          }
          else {
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
            this.errordata = [];
            this.appVerificationModel = [];
          }
        },
        error: (err) => {
          // this.loader.close();
          this.loading = false;
          this.activityRecordService.activityRecord(this.userID, 'Inventory Report', '', new Date(), err);

          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

        }
      });
    this.subscriptions.push(sub);
  }

  exportExcel(modelData, filename) {

    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        // console.log(d)
        return {
          "Auto ID": d.AutoID,
          "Login ID": d.LoginID,
          "Role Id": d.RoleId,
          "Action Type": d.ActionType,
          "Specific Id": d.SpecificId,
          "Status": d.Status,
          "Occurrence Date Time": d.OccurrenceDateTime,
          "Network Id": d.NetworkId,
          "Request Payload": d.RequestPayload,
        }
      })

      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }
  // downloadSheetAsPdf(modelData, filename) {
  //   this.cols = [
  //     {field: 'VendorName', header: 'Vendor Name'},
  //     {field: 'ProgrammeName', header: 'Programme Name'},
  //     { field: 'component', header: 'component' },
  //     { field: 'size', header: 'size' },
  //     {field: 'Quantity', header: 'Quantity'},
  //     {field: 'PreviouslyConsumedQuantity', header: 'Previously Consumed Quantity'},
  //     {field: 'RemaningQuantity', header: 'Remaning Quantity'},
  //     {field: 'BatchNO', header: 'BatchNO'},
  //     {field: 'LotNo', header: 'LotNo'},
  //     {field: 'PurchaseInvoiceNo', header: 'Purchase InvoiceNo'},
  //     {field: 'ItemType', header: 'Item Type'},

  //   ];

  //   this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

  //   import("jspdf").then(jsPDF => {
  //     import("jspdf-autotable").then(x => {
  //       const doc = new jsPDF.default(0, 0);
  //       doc.autoTable(this.exportColumns, modelData, {styles: {fontSize: 9 }});
  //       doc.save(`${filename}.pdf`);
  //     })
  //   })
  // }
  refreshTable() {
    this.loadData()
  }

  onResolvedClick(val) {
    if (val.Resolved == 1) {
      this.confirmationService.confirm({
        message: 'Changed Mind!!! Problem is still not resolved ?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          let reqBody = {
            AutoId: val.AutoID,
            StatusType: 'Resolved',
            Status: 0
          }
          this.loading = true;
          this.dashboard.UpdateActivityTracker(reqBody)
            .pipe(first())
            .subscribe({
              next: (data) => {
                this.loading = false;
                this.messageService.add({ severity: 'success', summary: 'Success Message', detail: JSON.stringify(data) });
                this.loadData();
              },
              error: (err) => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

              }
            });
        }
      });
    }
    else {
      this.confirmationService.confirm({
        message: 'Are you sure problem is resolved ?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          let reqBody = {
            AutoId: val.AutoID,
            StatusType: 'Resolved',
            Status: 1
          }
          this.loading = true;
          this.dashboard.UpdateActivityTracker(reqBody)
            .pipe(first())
            .subscribe({
              next: (data) => {
                this.loading = false;
                this.messageService.add({ severity: 'success', summary: 'Success Message', detail: JSON.stringify(data) });
                this.loadData();
              },
              error: (err) => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

              }
            });
        }
      });
    }
  }

  onNotRequiredClick(val) {
    if (val.NotRequired == 1) {
      this.confirmationService.confirm({
        message: 'Changed Mind!!! Want to take action?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          let reqBody = {
            AutoId: val.AutoID,
            StatusType: 'NA',
            Status: 0
          }
          this.loading = true;
          this.dashboard.UpdateActivityTracker(reqBody)
            .pipe(first())
            .subscribe({
              next: (data) => {
                this.loading = false;
                this.messageService.add({ severity: 'success', summary: 'Success Message', detail: JSON.stringify(data) });
                this.loadData();
              },
              error: (err) => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

              }
            });
        }
      });    }
    else {
      this.confirmationService.confirm({
        message: 'Are you sure action is not required ?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          let reqBody = {
            AutoId: val.AutoID,
            StatusType: 'NA',
            Status: 1
          }
          this.loading = true;
          this.dashboard.UpdateActivityTracker(reqBody)
            .pipe(first())
            .subscribe({
              next: (data) => {
                this.loading = false;
                this.messageService.add({ severity: 'success', summary: 'Success Message', detail: JSON.stringify(data) });
                this.loadData();
              },
              error: (err) => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

              }
            });
        }
      });
    }
  }
  showDialog(selectedData:any) {
    this.visible = true;
    // console.log(selectedData,"selectedData")
    this.selectedData=selectedData
}

onCloseDialog(){
  this.visible = false;
  this.selectedData = {};
}

  
}
